import { FuuzeButton, type FuuzeButtonProps } from '@fuuze/shared';
import type { PropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MdLogin, MdLogout } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useSignOut } from '../../Hooks/use-sign-out';
import { useUser } from '../../Hooks/use-user.hook';
import styles from './sign-out-or-sign-in.module.css';

type SignOutButtonProps = PropsWithoutRef<FuuzeButtonProps>;

export function SignOutOrSignInButton({ ...buttonProps }: SignOutButtonProps) {
  const { t } = useTranslation('components:leftNav', { keyPrefix: 'menuContent' });
  const user = useUser();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const onSignIn = () => {
    navigate('/login');
  };

  if (!user.data) {
    return (
      <FuuzeButton
        onClick={onSignIn}
        scaleOnHover
        type='button'
        style={{ width: 'fit-content', margin: '0 auto', ...buttonProps.style }}
        {...buttonProps}
      >
        <div className={styles.signInContentWrapper}>
          <p>{t('signIn')}</p>
          <MdLogin size={24} />
        </div>
      </FuuzeButton>
    );
  }

  return (
    <FuuzeButton
      flat
      onClick={signOut}
      type='button'
      style={{ width: 'fit-content', margin: '0 auto', ...buttonProps.style }}
      {...buttonProps}
    >
      <div className={styles.signOutContentWrapper}>
        <p>{t('signOut')}</p>
        <MdLogout size={24} />
      </div>
    </FuuzeButton>
  );
}
